(() => {
  const SELECTOR = '[data-lumerune-about-menu]';
  const CLOSE_DELAY = 180;

  const initMenu = (menu) => {
    if (menu.dataset.lumeruneAboutReady === 'true') return;

    const trigger = menu.querySelector('[data-lumerune-about-trigger]');
    const panel = menu.querySelector('[data-lumerune-about-panel]');
    if (!trigger || !panel) return;

    menu.dataset.lumeruneAboutReady = 'true';
    panel.inert = true;
    let closeTimer;
    let triggerPointerType = '';
    let wasOpenBeforePointer = false;

    const supportsHover = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    const open = () => {
      window.clearTimeout(closeTimer);
      document.querySelectorAll(SELECTOR).forEach(other => { if (other !== menu) { other.classList.remove('is-open'); other.querySelector('[data-lumerune-about-trigger]')?.setAttribute('aria-expanded', 'false'); other.querySelector('[data-lumerune-about-panel]').inert = true; } });
      menu.classList.add('is-open');
      panel.inert = false;
      trigger.setAttribute('aria-expanded', 'true');
    };

    const close = ({ restoreFocus = false } = {}) => {
      window.clearTimeout(closeTimer);
      if (restoreFocus) trigger.focus();
      menu.classList.remove('is-open');
      panel.inert = true;
      trigger.setAttribute('aria-expanded', 'false');
    };

    const scheduleClose = () => {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        if (!menu.contains(document.activeElement)) close();
      }, CLOSE_DELAY);
    };

    menu.addEventListener('pointerenter', (event) => {
      if (event.pointerType === 'mouse') open();
    });

    menu.addEventListener('pointerleave', (event) => {
      if (event.pointerType === 'mouse') scheduleClose();
    });

    menu.addEventListener('focusin', open);

    menu.addEventListener('focusout', (event) => {
      if (!menu.contains(event.relatedTarget)) scheduleClose();
    });

    trigger.addEventListener('pointerdown', (event) => {
      triggerPointerType = event.pointerType;
      wasOpenBeforePointer = menu.classList.contains('is-open');
    });

    trigger.addEventListener('click', (event) => {
      if (trigger.tagName === 'BUTTON') { event.preventDefault(); open(); return; }
      const isTouchInteraction = triggerPointerType === 'touch' || triggerPointerType === 'pen';
      const isCoarseOnlyDevice = !supportsHover() && triggerPointerType !== 'mouse';
      triggerPointerType = '';

      if ((isTouchInteraction || isCoarseOnlyDevice) && !wasOpenBeforePointer) {
        event.preventDefault();
        open();
      }
    });

    menu.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menu.classList.contains('is-open')) {
        event.preventDefault();
        close({ restoreFocus: true });
      }
    });

    document.addEventListener('pointerdown', (event) => {
      if (!menu.contains(event.target)) close();
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll(SELECTOR).forEach(initMenu);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

